<template>
  <div class="row d-flex justify-content-center align-items-center">
    <div
      class="index-item-description col-12 col-lg-6 order-1 mb-3 mb-lg-0"
      :class="{'order-lg-2': !isRightPhoto}"
    >
      <p class="write-right">
        <slot></slot>
      </p>
    </div>
    <router-link
      class="index-item-main d-block col-12 col-lg-6 order-2 mb-5 mb-lg-0"
      :class="{'order-lg-1': !isRightPhoto}"
      :to="link"
    >
      <img class="index-item-image" :src="imgSrc" :alt="imgAlt">
      <span class="index-item-name">
        <img src="../assets/arrow_right.png" alt="矢印">
        {{title}}
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "PhotoLinkAndText",
  components: {},
  props: {
    isRightPhoto: Boolean,
    title: String,
    // text: String,
    link: String,
    imgSrc: String,
    imgAlt: String,
    imgClass: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.write-right {
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  text-align: left;
  margin-right: 15px;
  letter-spacing: 0.1rem;
}

.index-item-image {
  width: 100%;
  object-fit: cover;
  max-height: 400px;
}

.index-item-name {
  position: absolute;
  left: 5px;
  bottom: 55px;
  text-align: left;
  color: white;
  font-size: 2rem;
  font-weight: 300;
  width: 16rem;
  background-color: rgba(0, 0, 0, 0.3);
}

.index-item-name img {
  margin: 0 10px 7px;
}

.index-item-main span {
  display: block;
  flex: 1;
  position: relative;
}

.index-item-description {
  display: flex;
  justify-content: center;
  align-items: center;
}
.index-item-description img {
  height: 180px;
}

.index-item-description p {
  font-size: 0.88rem;
}

</style>
